import React, { useState, useEffect } from "react";
const ES5PA2Update = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [formData, setFormData] = useState({
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        EmploymentId: Number(props.employmentId),
      
         CentalGovt3 : 0,
         UnionTerritory4 : 0,
         StateGovt5 : 0,
         CentalGovt6 : 0,
         StateGovt7 : 0,
         LocalBodies8 : 0,
         PrivateEstt9 : 0,
         Total10 : 0,

    });


    const getdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            ParametersId: Number(props.parametersId),
            EmploymentId: Number(props.employmentId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK+'api/Main/GetES5PA2Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                    //console.log(maindata)
                    setFormData({
                  
                        CentalGovt3: maindata.centalGovt3,
                        UnionTerritory4: maindata.unionTerritory4,
                        StateGovt5: maindata.stateGovt5,
                        CentalGovt6: maindata.centalGovt6,
                        StateGovt7: maindata.stateGovt7,
                        LocalBodies8: maindata.localBodies8,
                        PrivateEstt9: maindata.privateEstt9,
                        Total10: maindata.total10,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/UpdateDetailsES5PA2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    setFormData({

                        CentalGovt3: maindata.centalGovt3,
                        UnionTerritory4: maindata.unionTerritory4,
                        StateGovt5: maindata.stateGovt5,
                        CentalGovt6: maindata.centalGovt6,
                        StateGovt7: maindata.stateGovt7,
                        LocalBodies8: maindata.localBodies8,
                        PrivateEstt9: maindata.privateEstt9,
                        Total10: maindata.total10,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };

    




    useEffect(() => {
        getdata()

    }, [props.Change])

    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };
   

    return (
        load ? null:
        <tr scope="row"  >

            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                {props.sno} 

            </td>

            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 , }} >
                  {props.name}
            </td>
          
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10,  }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="CentalGovt3"
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="CentalGovt3"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.CentalGovt3}
                    /> : formData.CentalGovt3}

            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10,  }} >

                    {props.edit ? <input
                        min="0"
                        type="number"
                        id="UnionTerritory4"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="UnionTerritory4"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.UnionTerritory4}
                    /> : formData.UnionTerritory4}


            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10,  }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="StateGovt5"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="StateGovt5"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.StateGovt5}
                    /> : formData.StateGovt5}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10,  }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="CentalGovt6"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="CentalGovt6"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.CentalGovt6}
                    /> : formData.CentalGovt6}

            </td>
           
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="StateGovt7"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="StateGovt7"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.StateGovt7}
                    /> : formData.StateGovt7}

            </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="LocalBodies8"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="LocalBodies8"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.LocalBodies8}
                    /> : formData.LocalBodies8}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="PrivateEstt9"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"  maxLength="7" onKeyPress={inputHandler}
                        name="PrivateEstt9"
                        style={{ textAlign: 'center', minWidth: 70 }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40|| evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.PrivateEstt9}
                    /> : formData.PrivateEstt9}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    <label>{formData.Total10} </label>
                </td>

        </tr>
    );
};

export default ES5PA2Update;
